exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".map-page {\n  margin-top: 81px;\n  height: 520px; }\n\n@media only screen and (max-width: 414px) {\n  .map-page {\n    margin-top: 24px;\n    height: 248px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Map/index.scss
// module id = 120
// module chunks = 0